<div class="item text-small d-inline-flex link" [ngClass]="{'narrow': narrow}" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">

  <div class="d-flex align-items-center justify-content-center" style="min-height: 48px; min-width: 58px;" (click)="menuItemClicked(item)" [ngStyle]="position"
    title="{{ item.title }}">
    <span class="iconfont fs-32 {{item.icon}}" *ngIf="!item.image" [ngClass]="{'dNotify':!disableNotify && showDiscount && !expand}" ></span>
    <img [src]="item.image" class="item-img" *ngIf="!!item.image" />
    <!-- <span class="menu-label"></span> -->

    <!-- <div class="notifications showNum d-inline-flex align-items-center justify-content-center ng-star-inserted"
      *ngIf="(item.title === '通知') && ((user?.notifications?.messages +user?.notifications?.favorites > 0) || hasUnreadMessages)">
      <span>{{ (user?.notifications?.messages + user?.notifications?.favorites + concatsHasUnreadMessage.length) > 100 ? '99+' : (user?.notifications?.messages + user?.notifications?.favorites + concatsHasUnreadMessage.length) }}</span>
    </div> -->

    <div class="notifications d-inline-flex align-items-center justify-content-center ng-star-inserted"
      *ngIf="(item.title === '通知') && ((notifications.messages + notifications.favorites + notifications.follows > 0) || hasUnreadMessages)">
    </div>

    <!-- <div class="notifications d-inline-flex align-items-center justify-content-center ng-star-inserted"
      *ngIf="(item.title === '订阅') && (notifications?.subscriptions > 0)">
    </div> -->
  </div>

  <div [hidden]="!expand">
    <ng-template appDropdownHost></ng-template>
  </div>
  <span class="dCaption" *ngIf="!disableNotify && showDiscount  && !expand">{{notifyCaption}}</span>

  <!-- <div class="discount" *ngIf="showDiscount">惠</div> -->
  <!-- <div class="discount" *ngIf="showDiscount"></div> -->
</div>
